<template>
    <div class="lottery-combos-picker" data-test="combinations-board">
        <DsCheckboxOption
            class="lottery-combos-picker__cell"
            v-for="combo in KAMENY_COMBOS"
            :key="`combo-${combo.id}`"
            :id="`combo-${combo.id}`"
            :name="`combo-${combo.id}`"
            :label="combo.text"
            :supporting-text="
                showMultiplier ? combo.multiplier.toLocaleString('en').replace(/,/g, '\u00A0') + 'x' : null
            "
            v-model="model"
            :value="combo.id"
            @change="emit('comboPicked')"
            data-test-label="combination"
            :data-test-value-input="combo.text"
        />
    </div>
</template>

<script setup lang="ts">
import DsCheckboxOption from "@sazka/design-system/src/forms/components/ds-checkbox-option.vue";
import { KAMENY_COMBOS } from "../data/kameny-constants";

const emit = defineEmits(["comboPicked"]);

const model = defineModel<number[]>();

defineProps<{ showMultiplier?: boolean }>();
</script>
